import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { setCateCd, setPdtCate } from '@app/actions/shoppingmall/product.action';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { ConvertUtil } from '@app/common/util/convert.util';
import { PdtCateState } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { Store } from '@ngrx/store';

declare const mainBrandSlide: any;

@Component({
  selector: 'hp-brand',
  templateUrl: './hp-brand.component.html',
  styleUrls: ['./hp-brand.component.css']
})
export class HpBrandComponent implements OnInit {

  constructor(
    private _router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private _pdtCateStore: Store<PdtCateState>,
    private _productStore: Store<ProductState>,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      mainBrandSlide();

      const paginationLinks = this.el.nativeElement.querySelectorAll('.pagination-link');

      paginationLinks.forEach((link: HTMLElement) => {
        this.renderer.listen(link, 'click', () => this.handleClickCate('ALL'));
      });
    }, 1);
  }

  handleClickCate(pdtCate: string) {
    sessionStorage.setItem("category", pdtCate);
    this._pdtCateStore.dispatch(setPdtCate({ cate: ConvertUtil.convertToSring(pdtCate) }));
    this._productStore.dispatch(setCateCd({ cateCd: pdtCate }));
    this._router.navigate([MyProgramConstant.urlShopping + '/category/' + pdtCate]);
  }
}
